import ReactDOM from "react-dom";
import { Lock, X } from "lucide-react";

// Reusable "Need to Unlock" popup. Shown when a creator taps a feature (Tips / Amazon)
// they haven't earned yet. Rendered in a Portal so parent transforms never clip it.
export default function UnlockGateModal({ open, onClose, feature, min, count = 0 }) {
  if (!open) return null;
  const remaining = Math.max(0, (min || 0) - (count || 0));
  const pct = min ? Math.min(100, Math.round((count / min) * 100)) : 0;

  return ReactDOM.createPortal(
    <div
      className="fixed inset-0 z-[120] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
      onClick={onClose}
      data-testid="unlock-gate-modal"
    >
      <div
        className="bg-white rounded-3xl w-full max-w-sm shadow-2xl overflow-hidden border border-[#dfe7d8] sms-fade-up"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="relative px-6 py-5 text-white" style={{ background: "linear-gradient(135deg,#5d8a52,#3f6238)" }}>
          <button data-testid="unlock-gate-close" onClick={onClose} className="absolute top-3 right-3 p-1.5 rounded-full hover:bg-white/15 transition-colors"><X size={20} /></button>
          <div className="flex items-center gap-2.5">
            <span className="w-10 h-10 rounded-xl bg-white/15 flex items-center justify-center shrink-0"><Lock size={20} /></span>
            <div>
              <h3 className="text-lg font-extrabold leading-tight">🔒 {feature} is locked</h3>
              <p className="text-[13px] font-semibold text-white/85 leading-tight">Keep creating to unlock it.</p>
            </div>
          </div>
        </div>

        <div className="px-6 py-6 text-center">
          <p className="text-sm text-[#4b4860]" data-testid="unlock-gate-message">
            Publish <span className="font-extrabold text-[#3f6238]">{remaining} more video{remaining === 1 ? "" : "s"}</span> to the Community to unlock <span className="font-extrabold text-[#171426]">{feature}</span>.
          </p>

          <div className="mt-5 text-4xl font-extrabold text-[#171426] tabular-nums leading-none">
            {count}<span className="text-[#9a96ac] text-2xl"> / {min}</span>
          </div>
          <div className="text-xs font-bold text-[#5d8a52] mt-1">videos published</div>

          <div className="mt-4 h-3 rounded-full bg-[#eef3ea] overflow-hidden">
            <div className="h-full rounded-full transition-all duration-500" style={{ width: `${pct}%`, background: "linear-gradient(90deg,#5d8a52,#3f6238)" }} data-testid="unlock-gate-bar" />
          </div>

          <button
            data-testid="unlock-gate-cta"
            onClick={onClose}
            className="w-full mt-6 font-extrabold text-white py-3 rounded-2xl transition-transform hover:scale-[1.02]"
            style={{ background: "linear-gradient(135deg,#5d8a52,#3f6238)" }}
          >
            Keep creating 🎬
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
